<template>
  <div class="layer">
      <div class="inner categoryInner">
        <button type="button" class="btnClose" @click="close"></button>
        <h2 class="layerTitle">{{ locale.default_settings }}</h2>
        <div class="flexBox innerContent">
          <div class="flexInner">
            <div class="label groupLabel mb15">{{ locale.color }}</div>
            <div class="mb15">
              <div class="label setLabel mb5">{{ locale.page_background }}</div>
              <ColorPicker
                class="mt5"
                :target="'backgroundColor'"
                :color="collectionPage.backgroundColor"
                :useColorOnly="true"
                @changeColor="changeColor" />
            </div>
            <div class="mb15">
              <div class="label setLabel mb5">{{ locale.text_color }}</div>
              <ColorPicker
                class="mt5"
                :target="'fontColor'"
                :color="collectionPage.fontColor"
                :useColorOnly="true"
                @changeColor="changeColor" />
            </div>
            <div class="mb30">
              <div class="label setLabel mb5">{{ locale.point_color }}</div>
              <ColorPicker
                class="mt5"
                :target="'pointColor'"
                :color="collectionPage.pointColor"
                :useColorOnly="true"
                @changeColor="changeColor" />
            </div>
            <div class="mb30">
              <div class="label groupLabel mb15">{{ locale.frame }}</div>
              <div>
                <div class="label setLabel mb5">
                  <div class="checkbox">
                    <input type="checkbox" id="use_pageframe_active" v-model="usePageFrame.isActive">
                    <label for="use_pageframe_active">{{ locale.page_frame }}</label>
                  </div>
                </div>
                <div class="unitInput">
                  <input
                    type="text"
                    class="input"
                    :disabled="!usePageFrame.isActive"
                    v-model="usePageFrame.size">
                  <span class="unit">px</span>
                </div>
              </div>
            </div>
            <div class="label groupLabel mb15">{{ locale.text }}</div>
            <div class="mb15">
              <div class="label setLabel mb5">{{ locale.size }}</div>
                <div class="unitInput">
                  <input
                    type="text"
                    class="input"
                    v-model="collectionPage.fontSize">
                  <span class="unit">px</span>
                </div>
            </div>
            <div class="mb5">
              <div class="label setLabel mb5">{{ locale.letter_spacing }}</div>
              <div>
                <select class="input select" v-model="collectionPage.spacing">
                  <option
                    v-for="spacing in spacingList"
                    :key="spacing"
                    :value="`${spacing}`">
                    {{ spacing }}
                  </option>
                </select>
                <div class="mt15">
                  <p class="mt5">아이템 이름</p>
                  <select class="input select" v-model="collectionPage.nameSpacing">
                    <option value="">지정 안함</option>
                    <option
                      v-for="spacing in spacingList"
                      :key="spacing"
                      :value="`${spacing}`">
                      {{ spacing }}
                    </option>
                  </select>
                  <p class="mt5">아이템 설명</p>
                  <select class="input select" v-model="collectionPage.descTopSpacing">
                    <option value="">지정 안함</option>
                    <option
                      v-for="spacing in spacingList"
                      :key="spacing"
                      :value="`${spacing}`">
                      {{ spacing }}
                    </option>
                  </select>
                  <p class="mt5">아이템 하단 설명</p>
                  <select class="input select" v-model="collectionPage.descBottomSpacing">
                    <option value="">지정 안함</option>
                    <option
                      v-for="spacing in spacingList"
                      :key="spacing"
                      :value="`${spacing}`">
                      {{ spacing }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <!-- 이미지 -->
          <div class="flexInner" data-flex="2" data-responsive="wide">
            <div class="label groupLabel mb15">{{ locale.image }}</div>
            <p class="sysMessage">{{ locale.message_collection_main_images }}</p>
            <!-- 메인 -->
            <div class="mb15">
              <div class="label setLabel">{{ locale.page_main_image }}</div>
              <div v-if="usePageMain.image" class="bgThumb">
                <img :src="usePageMain.image" alt="">
                <button type="button" class="delThumb" @click="deleteImage('usePageMain')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_pagemain_image" @change="uploadImage($event, 'usePageMain')">
                <label for="upload_pagemain_image" class="btn toUppercase">{{locale.upload}}</label>
              </div>
            </div>
            <!-- //메인 -->
            <!-- 인트로 -->
            <div class="mb15">
              <div class="label setLabel mb5">
                <div class="checkbox">
                  <input type="checkbox" id="use_pageintro_active" v-model="usePageIntro.isActive">
                  <label for="use_pageintro_active">{{ locale.page_intro_image }}</label>
                </div>
              </div>
              <p class="sysMessage colorGrey mb10">{{ locale.message_page_intro_image }}</p>
              <div v-if="usePageIntro.image" class="bgThumb mt5">
                <img :src="usePageIntro.image" alt="">
                <button type="button" class="delThumb" @click="deleteImage('usePageIntro')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_pageintro_image" @change="uploadImage($event, 'usePageIntro')">
                <label for="upload_pageintro_image" class="btn toUppercase mt5">{{locale.upload}}</label>
              </div>
            </div>
            <!-- //인트로 -->
            <!-- 커버 -->
            <div class="mb15">
              <div class="label setLabel mb5">
                <div class="checkbox">
                  <input type="checkbox" id="use_pagecover_active" v-model="usePageCover.isActive">
                  <label for="use_pagecover_active">{{ locale.page_cover_image }}</label>
                </div>
              </div>
              <p class="sysMessage colorGrey mb10">{{ locale.message_page_cover_image }}</p>
              <div v-if="usePageCover.image" class="bgThumb mt5">
                <img :src="usePageCover.image" alt="">
                <button type="button" class="delThumb" @click="deleteImage('usePageCover')"><img src="~@/assets/img/ico_close.svg" alt=""></button>
              </div>
              <div v-else>
                <input type="file" id="upload_pagecover_image" @change="uploadImage($event, 'usePageCover')">
                <label for="upload_pagecover_image" class="btn toUppercase mt5">{{locale.upload}}</label>
              </div>
            </div>
            <!-- //커버 -->
          </div>
          <!-- //이미지 -->
        </div>
        <div class="btns">
          <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
          <button type="button" class="btn btnPrimary" @click="save">{{ locale.save }}</button>
        </div>
      </div>
    </div>
</template>

<script>
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import ColorPicker from '@/components/Util/ColorPicker'

export default {
  name: 'CollectionSettings',
  props: [
    'locale',
    'settings'
  ],
  components: {
    ColorPicker
  },
  computed: {
  },
  async created () {
    if (this.settings) {
      this.collectionPage = {
        ...this.collectionPage,
        ...this.settings.collectionPage
      }
      this.usePageFrame = {
        ...this.usePageFrame,
        ...this.settings.usePageFrame
      }
      this.usePageCover = {
        ...this.usePageCover,
        ...this.settings.usePageCover
      }
      this.usePageIntro = {
        ...this.usePageMain,
        ...this.settings.usePageIntro
      }
      this.usePageMain = {
        ...this.usePageMain,
        ...this.settings.usePageMain
      }
    }
    // letter-spacing 옵션
    function createSpacing () {
      const min = -100
      const max = 250
      const diff = 25
      const arr = []
      for (let i = min; i <= max; i += diff) {
        arr.push(`${i}`)
      }
      return arr
    }
    this.spacingList = createSpacing()
  },
  data () {
    return {
      spacingList: [],
      collectionPage: {
        backgroundColor: 'rgba(255,255,255,1)',
        pointColor: 'rgba(0,0,0,1)',
        fontColor: 'rgba(30,30,30,1)',
        fontSize: '14',
        spacing: '0',
        nameSpacing: '',
        descTopSpacing: '',
        descBottomSpacing: ''
      },
      usePageFrame: {
        isActive: true,
        size: '40'
      },
      usePageCover: {
        isActive: true,
        image: ''
      },
      usePageIntro: {
        isActive: true,
        image: ''
      },
      usePageMain: {
        isActive: true,
        image: ''
      }
    }
  },
  methods: {
    changeColor (data) {
      this.collectionPage[data.target] = data.color
    },
    uploadImage (e, target) {
      const data = {
        id: UNIQUE.mid(),
        file: e.target.files[0]
      }
      const isImage = regExp.image.test(data.file.name.slice(data.file.name.lastIndexOf('.') + 1).toLowerCase())
      if (isImage) {
        this.$store.dispatch('util/uploadFile', data).then((res) => {
          this[target].image = res.source
          e.target.value = ''
        })
      } else {
        alert(this.locale.validate_upload_image)
      }
    },
    deleteImage (target) {
      if (window.confirm(this.locale.confirm_delete)) {
        console.log(target)
        this[target].image = ''
      }
    },
    close () {
      if (window.confirm(this.locale.confirm_cancel)) {
        this.$emit('close')
      }
    },
    save () {
      const data = {
        collectionPage: this.collectionPage,
        usePageFrame: this.usePageFrame,
        usePageCover: this.usePageCover,
        usePageIntro: this.usePageIntro,
        usePageMain: this.usePageMain
      }
      this.$emit('save', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 780px;
  }
  .innerContent {
    min-height: 520px;
    overflow: auto;
  }
}
</style>
